// =============================================================================
// droitRH.js : le droit « RH Maître » porté jusqu'au rail, sans requête de plus.
// -----------------------------------------------------------------------------
// Le RH Maître (rôle rh_maitre du compte recruteur) n'est connu que de la CF
// rhWhoAmI, que RHModule appelle à son ouverture pour garder ses pages
// réservées (modèles de processus, grilles d'évaluation, modèles d'e-mails
// candidats, personnalisation). RHModule NOTE ici la réponse (noterDroitRH) ;
// App la lit (useDroitRH) et la passe à buildNavModules : le rail, la feuille
// « Modules », la palette, le fil et l'accueil RH montrent alors les mêmes
// entrées (src/accueilsAlignes.test.js).
//   • aucune requête au démarrage : le rail apprend le droit à l'entrée dans
//     le module RH ; avant, échec fermé (les quatre pages restent hors du
//     rail, et RHModule les refuse de toute façon) ;
//   • mémorisé pour l'onglet (sessionStorage, par identifiant de session) :
//     un rechargement ne fait pas perdre au rail ce que RHModule a lu ; toute
//     nouvelle lecture, positive ou négative, remplace la mémoire ;
//   • une mémoire altérée n'ouvre qu'une entrée de menu, jamais une page : les
//     pages restent gardées par RHModule et par les fonctions.
// La clé est la session que reçoit RHModule (celle de « Voir comme », comme le
// menu) : le rail suit exactement la garde des pages.
// =============================================================================
import { useEffect, useState } from "react";

const CLE = "rh_droit";
const EVENEMENT = "aramis:droit-rh";

/** Le seul champ retenu d'une réponse de rhWhoAmI : `isRhMaitre === true`. */
export const estRhMaitre = (reponse) => !!(reponse && reponse.isRhMaitre === true);

export function lireDroitRH(sessionId) {
  if (!sessionId) return false;
  try {
    const m = JSON.parse(sessionStorage.getItem(CLE) || "null");
    return !!(m && m.sessionId === sessionId && m.rhMaitre === true);
  } catch { return false; }
}

/** Retient la réponse de rhWhoAmI (ou son échec : `null`) et prévient le rail. */
export function noterDroitRH(sessionId, reponse) {
  if (!sessionId) return;
  const rhMaitre = estRhMaitre(reponse);
  try { sessionStorage.setItem(CLE, JSON.stringify({ sessionId, rhMaitre })); } catch { /* onglet sans stockage */ }
  try { window.dispatchEvent(new CustomEvent(EVENEMENT, { detail: { sessionId, rhMaitre } })); } catch { /* rien */ }
}

/** Le droit RH Maître de la session, tel que RHModule l'a lu en dernier. */
export function useDroitRH(sessionId) {
  const [etat, setEtat] = useState(() => ({ sessionId, rhMaitre: lireDroitRH(sessionId) }));
  useEffect(() => {
    setEtat({ sessionId, rhMaitre: lireDroitRH(sessionId) });
    const surNote = (e) => {
      if (e && e.detail && e.detail.sessionId === sessionId) setEtat({ sessionId, rhMaitre: e.detail.rhMaitre === true });
    };
    window.addEventListener(EVENEMENT, surNote);
    return () => window.removeEventListener(EVENEMENT, surNote);
  }, [sessionId]);
  // Changement de session (« Voir comme ») : jamais le droit de la précédente.
  return etat.sessionId === sessionId ? etat.rhMaitre : lireDroitRH(sessionId);
}
